import { render } from "./callToAction.vue?vue&type=template&id=62c88e0e&scoped=true"
import script from "./callToAction.vue?vue&type=script&lang=js"
export * from "./callToAction.vue?vue&type=script&lang=js"

import "./callToAction.vue?vue&type=style&index=0&id=62c88e0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c88e0e"]])

export default __exports__